/**
 * Copyright (C) 2018-2026 Cole Engineering Services, Inc. a By Light Company
 *
 * All Rights Reserved.
 *
 * Cole Engineering Services, Inc.: www.cesicorp.com
 *                                  2750 Discovery Drive
 *                                  Orlando, FL 32826
 *                                  (407) 674-8300
 */

import {
    AutoRefreshTokenService,
    createInterceptorCondition,
    INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    IncludeBearerTokenCondition, ProvideKeycloakOptions, UserActivityService, withAutoRefreshToken } from 'keycloak-angular';
import { KeycloakOnLoad } from 'keycloak-js';

import { KeycloakInfo } from './shared/models/keycloak-info';

let keycloakConfig: ProvideKeycloakOptions;

export function setKeycloakConfig(keycloakInfo: KeycloakInfo): void {
    keycloakConfig = {
        config: {
            url: keycloakInfo.keycloakHost,
            realm: keycloakInfo.realm,
            clientId: keycloakInfo.frontendClient,
        },
        initOptions: {
            checkLoginIframe: true,
            checkLoginIframeInterval: 15,
            enableLogging: true,
            onLoad: 'check-sso' as KeycloakOnLoad,
            silentCheckSsoRedirectUri: window.location.origin + '/portal/assets/silent-check-sso.html',
        },
        features: [
            withAutoRefreshToken({
                onInactivityTimeout: 'none',
            }),
        ],
        providers: [
            AutoRefreshTokenService,
            UserActivityService,
            {
                provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
                useValue: [
                    createInterceptorCondition<IncludeBearerTokenCondition>({
                        urlPattern: /^.*$/i, // Attach Bearer header to outgoing requests to URLs matching this pattern
                    }),
                ], // Specify conditions for adding the Bearer token
            },
        ],
    };
}

export function getKeycloakConfig(): ProvideKeycloakOptions {
    return keycloakConfig;
}
